export const NUMBER_OF_DAYS_PER_MONTH = 30

export const SELECT_ALL_OPTION_VALUE = '*'
